import React, { useState, useMemo, useEffect } from "react";
import Select from "react-select";
// import { faEdit, faTrash, faInfoCircle  } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from "react-tooltip"; // Use the named export
import "react-tooltip/dist/react-tooltip.css"; // Import the CSS for styling
import { useTable, useSortBy, usePagination } from "react-table";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEllipsisV,
  faTrash,
  faUser,
  faInfoCircle,
  faSyncAlt,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import imageCompression from "browser-image-compression";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
const AddSewadarForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [sewadars, setSewadars] = useState([]);
  const [editSewadarId, setEditSewadarId] = useState(null);
  const [access, setAccess] = useState("No"); // Default No

  const [isSaving, setIsSaving] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  // Form state
  const [badgeId, setBadgeId] = useState("");
  const [zonalBadge, setZonalBadge] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [department, setDepartment] = useState([]);
  const [position, setPosition] = useState("Sewadar");
  const [prefix, setPrefix] = useState([]);
  const [prefixes, setPrefixes] = useState([]);
  const [signature, setSignature] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [signatureFileName, setSignatureFileName] = useState(
    "No signature uploaded"
  );
  const [sewadarOf, setSewadarOf] = useState("");
  const [selectedLedger, setSelectedLedger] = useState([]); // Initialize as empty array

  const [departments, setDepartments] = useState([]);
  const [departmentGroupOptions, setdepartmentGroupOptions] = useState([]);
  const [departmentGroup, setDepartmentGroup] = useState([]);
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const centerCode = localStorage.getItem("code");
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");
  const loginEmail = localStorage.getItem('email');

  const location = useLocation();
  const { row } = location.state || {};

  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise.all([fetchDepartments(), fetchPrefix()]);
      } catch (err) {
        console.error("Initial data fetch failed", err);
      } finally {
        setLoadingData(false); // ✅ Hide spinner when both are done
      }
    };
    fetchInitialData();
  }, [centerCode]);

  const fetchDepartments = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/departments", {
        params: { code: centerCode },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
        // Pass 'centerCode' as a parameter in the request
      });
      // Map the response data to options for the Select component
      const options = response.data.map((dept) => ({
        value: dept.name,
        label: dept.name,
      }));
      // setdepartmentGroupOptions(deparmentOptions)
      setDepartments(options);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchPrefix = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/prefixDetails", {
        params: { code: centerCode },

        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
        // Pass 'centerCode' as a parameter in the request
      });

      // Map the response data to options for the Select component
      const options = response.data.map((pre) => ({
        value: pre.prefix,
        label: pre.prefix,
      }));
      setPrefixes(options);
    } catch (error) {
      console.error("Error fetching prefix:", error);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Compress the image
        const options = {
          maxSizeMB: 1, // Maximum file size in MB
          maxWidthOrHeight: 1024, // Max width/height of the image
          useWebWorker: true, // Use multi-threading for performance
        };
        const compressedFile = await imageCompression(file, options);

        // Convert to Base64
        const reader = new FileReader();
        reader.onloadend = () => {
          setSignature(reader.result); // Base64 string
        };
        reader.readAsDataURL(compressedFile);
      } catch (error) {
        console.error("Error compressing the image:", error);
      }
    }
  };
  const getOptions = () => {
    return [{ value: "all", label: "Select All" }, ...departments];
  };
  const handleSetDepartment = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      setDepartment(departments);
    } else {
      setDepartment(selectedOptions);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: At least one of Badge ID or Zonal Badge ID must be filled
    if (!badgeId && !zonalBadge) {
      Swal.fire({
        icon: "error",
        text: "Please fill at least one of Badge ID or Zonal Badge ID.",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
      setIsSaving(false); // Start loading
      return;
    }
    const payload = {
      loginEmail,
      badgeId,
      zonalBadge,
      firstName,
      lastName,
      username,
      email,
      contactNo,
      position,
      departments: department.map((d) => d.value),
      prefixes: prefix.map((p) => p.value),
      // departmentalGroupCode:departmentGroup.map((t)=>t.value),
      centerCode,
      signature,
      sewadarOf,
      access,
      selectedLedgers: selectedLedger.map((ledger) => ledger.value).join(","), // Send only IDs
    };
    setIsSaving(true); // Start loading
    try {
      if (row) {
        // Update API call
        await apiClient.post(
          `${SERVER_BASE}/editSewadar/${editSewadarId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
          }
        );
        Swal.fire({
          icon: "success",
          title: "Sewadar updated successfully!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        }).then(() => {
          setIsSaving(false); // Start loading
          navigate("../sewadarList");
        });
      } else {
        // Create API call
        const response = await apiClient.post(
          `${SERVER_BASE}/addSewadar`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
          }
        );
        setSewadars((prev) => [...prev, response.data]);
        Swal.fire({
          icon: "success",
          title: response?.data?.message,
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        }).then(() => {
          navigate("../sewadarList");
        });
      }
    } catch (error) {
      setIsSaving(false); // Start loading
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: error?.response?.data?.message,
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  useEffect(() => {
    fetchledgermasterdetails();
  }, []);

  useEffect(() => {
    if (row) {
      handleEdit(row);
    }
  }, [row]);
  const handleEdit = (sewadar) => {
    setEditSewadarId(sewadar.id);
    setBadgeId(sewadar.badgeId);
    setZonalBadge(sewadar.zonalBadgeId);
    setFirstName(sewadar.firstName);
    setLastName(sewadar.lastName);
    setUsername(sewadar.username);
    setEmail(sewadar.email);
    setContactNo(sewadar.contactNo);
    // Ensure department and prefix are arrays
    const departmentArray = Array.isArray(sewadar.department)
      ? sewadar.department
      : sewadar.department
        ? sewadar.department.split(",") // If comma-separated string
        : [];
    setDepartment(departmentArray.map((d) => ({ value: d, label: d })));

    const prefixArray = Array.isArray(sewadar.prefix)
      ? sewadar.prefix
      : sewadar.prefix
        ? sewadar.prefix.split(",")
        : [];
    setPrefix(prefixArray.map((p) => ({ value: p, label: p })));
    setSewadarOf(sewadar.sewadarOf);
    setPosition(sewadar.position);

    setAccess(sewadar.access);
    if (sewadar.signImage) {
      const base64String = sewadar.signImage;
      const mimeType = base64String.match(/data:(.*?);base64/)[1];
      const extension = mimeType.split("/")[1];
      const signatureFileName = `signature.${extension}`;
      setSignatureFileName(signatureFileName);
    } else {
      setSignatureFileName("No signature uploaded");
    }
  };
  useEffect(() => {
    if (row && ledgerOptions.length > 0) {
      const ledgersArray = Array.isArray(row.selectedLedgers)
        ? row.selectedLedgers
        : row.selectedLedgers
          ? row.selectedLedgers.split(",")
          : [];

      const selectedLedgers = ledgersArray.map((val) => {
        const ledger = ledgerOptions.find((opt) => opt.value == val);
        return ledger
          ? { value: ledger.value, label: ledger.label }
          : { value: val, label: val };
      });

      setSelectedLedger(selectedLedgers);
    }
  }, [row, ledgerOptions]);

  const fetchledgermasterdetails = async () => {
    try {
      const response = await apiClient.get(
        SERVER_BASE + "/ledgerMastersMainTain",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        }
      );
      const options = response.data.map((ledger) => ({
        value: ledger?.id,
        label: ledger?.printName,
        group: ledger?.ledgerGroup,
        address: ledger?.address,
        gstin: ledger?.gstin,
        state: ledger?.state,
        stateCode: ledger?.stateCode,
        areaJurisdiction: ledger?.areaJurisdiction,
        ledgerGroupCode: ledger?.ledgerGroupCode,
        centerType: ledger?.centerType,
      }));
      setLedgerOptions(options);
      // setledgerMasterData(response.data);
    } catch (error) {
      console.error("Error fetching ledger master details:", error);
    }
  };

  const resetForm = () => {
    setBadgeId("");
    setZonalBadge("");
    setFirstName("");
    setLastName("");
    setUsername("");
    setEmail("");
    setContactNo("");
    setDepartment([]);
    setPosition("Sewadar");
    setPrefix([]);
    // setDepartmentGroup([]);
    setSignature(null);
    setShowForm(false);
    setIsEdit(false);
    setEditSewadarId(null);
  };
  if (loadingData) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <div
          className="spinner-border text-success"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Loading Sewadar Form...</div>
      </div>
    );
  }

  return (
    <div className="container mt-5">

      <form onSubmit={handleSubmit} className="formcontainer mb-4">
        <div className="d-flex gap-3">
          <button
            className="btn btn-success mb-3"
            onClick={() => {
              navigate("../SewadarList");
            }}
          >
            Back
          </button>
          <h3>Sewadar</h3>
        </div>
        <div className="row mb-3">
          <div className="col-md-3">
            <label htmlFor="badgeId">Badge ID *</label>
            <input
              type="text"
              id="badgeId"
              className="form-control"
              value={badgeId}
              onChange={(e) => setBadgeId(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="badgeId">Zonal Badge ID *</label>
            <input
              type="text"
              id="zonalBadge"
              className="form-control"
              value={zonalBadge}
              onChange={(e) => setZonalBadge(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="firstName">First Name*</label>
            <input
              type="text"
              id="firstName"
              className="form-control"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="lastName">Last Name*</label>
            <input
              type="text"
              id="lastName"
              className="form-control"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-3">
            <label>Position *</label>
            <select
              className="form-select"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
            >
              <option value="Sewadar">1. Sewadar</option>
              <option value="Approver">2. Approver</option>
              <option value="Authorized Person">
                3. Authorized Person
              </option>
              <option value="Main Incharge">4. Main Incharge</option>
            </select>
          </div>
          <div className="col-md-3">
            <label htmlFor="username">Username *</label>
            <input
              type="text"
              id="username"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="contactNo">Contact No *</label>
            <input
              type="text"
              id="contactNo"
              className="form-control"
              value={contactNo}
              onChange={(e) => setContactNo(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="row mb-3">

          <div className="col-md-4">
            <label>Main Department*</label>
            <Select
              options={departments} // Example: [{ label: 'HR', value: 'hr' }, ...]
              value={departments.find((dep) => dep.value == sewadarOf)} // Find selected option
              onChange={(selected) => setSewadarOf(selected?.value)} // Update state
              placeholder="Select department"
              isClearable
            />
          </div>
          <div className="col-md-4">
            <label>Upload Signature as Image</label>
            <input
              type="file"
              className="form-control"
              id="signature"
              accept="image/*"
              onChange={handleFileChange}
            />
            {isEdit && <p>{signatureFileName}</p>}
          </div>
          <div className="col-md-4">
            <label>Access</label>
            <Select
              options={[
                { value: "Department", label: "Department" },
                { value: "Ledger", label: "Ledger" },
                { value: "Both", label: "Both" },
              ]}
              value={{ value: access, label: access }}
              onChange={(selected) => {
                setAccess(selected.value);
                if (selected.value === "No") {
                  setSelectedLedger([]); // Clear ledger if No
                }
              }}
            />
          </div>
          {(access == "Department" || access == "Both") ?
          (<div className="col-md-12">
            <label> Access of Department Stores *</label>
            <Select
              isMulti
              options={getOptions()} // Use the fetched department options
              value={department} // Selected departments
              onChange={handleSetDepartment} // Update the state on change
            />
          </div>):null}
          {(access == "Ledger" || access == "Both")  ? (
            <div className="col-md-12">
              <label>Ledger</label>
              <Select
                isMulti
                options={[{ value: "all", label: "Select All" }, ...ledgerOptions]}
                value={selectedLedger}
                onChange={(selectedOptions) => {
                  if (!selectedOptions) {
                    setSelectedLedger([]);
                    return;
                  }

                  // Check if "Select All" was chosen
                  if (selectedOptions.some((opt) => opt.value === "all")) {
                    setSelectedLedger(ledgerOptions); // Select all ledgers
                  } else {
                    setSelectedLedger(selectedOptions);
                  }
                }}
                placeholder="Select ledger(s)"
              />
            </div>
          ):null}

        </div>
        <div>
          <button
            type="submit"
            className="btn btn-success"
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
          {/* {isEdit && <button type="submit" className="btn btn-success" onClick={resetForm}>Cancel</button>} */}
        </div>
      </form>


    </div>
  );
};

export default AddSewadarForm;
